import { render, staticRenderFns } from "./m-product-sfgallery.vue?vue&type=template&id=2e0d581e&"
import script from "./m-product-sfgallery.vue?vue&type=script&lang=js&"
export * from "./m-product-sfgallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports